import template from './addPermissionsModal.html';
import controller from './addPermissionsModal.controller';

let AddPermissionsModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'lg',
  windowClass: 'hmodal-info animated zoomIn'
};

export default AddPermissionsModalComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/role-management/modals/addPermissionsModal/addPermissionsModal.component.js